import { render, staticRenderFns } from "./gl-user-dropdown.vue?vue&type=template&id=350671c4"
import script from "./gl-user-dropdown.vue?vue&type=script&lang=js"
export * from "./gl-user-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports